import { defineRecipe } from "@chakra-ui/react";

// Restores the Chakra v2 input size; `chakra-react-select` styles its control from this recipe.
const inputRecipe = defineRecipe({
  base: {
    borderRadius: "md",
  },
  variants: {
    size: {
      md: {
        textStyle: "md",
        px: "4",
      },
    },
  },
});

export default inputRecipe;
